/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * <I>Available values</I> : id, -id, total_transactions, -total_transactions, created_timestamp, -created_timestamp, owner, -owner
 */
export const ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy = {
  Id: "id",
  MinusId: "-id",
  TotalTransactions: "total_transactions",
  MinusTotalTransactions: "-total_transactions",
  CreatedTimestamp: "created_timestamp",
  MinusCreatedTimestamp: "-created_timestamp",
  Owner: "owner",
  MinusOwner: "-owner",
} as const;
/**
 * <I>Available values</I> : id, -id, total_transactions, -total_transactions, created_timestamp, -created_timestamp, owner, -owner
 */
export type ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy =
  ClosedEnum<typeof ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy>;

export type ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest = {
  ledgerCanisterId: string;
  /**
   * Only match values after this id
   */
  after?: Array<string> | undefined;
  /**
   * Only match values before this id
   */
  before?: Array<string> | undefined;
  limit?: number | undefined;
  /**
   * <I>Available values</I> : id, -id, total_transactions, -total_transactions, created_timestamp, -created_timestamp, owner, -owner
   */
  sortBy?:
    | ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy
    | undefined;
};

/** @internal */
export const ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$inboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy
  > = z.nativeEnum(ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy);

/** @internal */
export const ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$outboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy
  > = ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$ {
  /** @deprecated use `ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$inboundSchema;
  /** @deprecated use `ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$outboundSchema;
}

/** @internal */
export const ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema:
  z.ZodType<
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    after: z.array(z.string()).optional(),
    before: z.array(z.string()).optional(),
    limit: z.number().int().default(20),
    sort_by:
      ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$inboundSchema
        .default("id"),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "sort_by": "sortBy",
    });
  });

/** @internal */
export type ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$Outbound =
  {
    ledger_canister_id: string;
    after?: Array<string> | undefined;
    before?: Array<string> | undefined;
    limit: number;
    sort_by: string;
  };

/** @internal */
export const ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema:
  z.ZodType<
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$Outbound,
    z.ZodTypeDef,
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    after: z.array(z.string()).optional(),
    before: z.array(z.string()).optional(),
    limit: z.number().int().default(20),
    sortBy:
      ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetSortBy$outboundSchema
        .default("id"),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      sortBy: "sort_by",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$ {
  /** @deprecated use `ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema;
  /** @deprecated use `ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema;
  /** @deprecated use `ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$Outbound` instead. */
  export type Outbound =
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$Outbound;
}

export function listAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequestToJSON(
  listAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest:
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest,
): string {
  return JSON.stringify(
    ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$outboundSchema
      .parse(listAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest),
  );
}

export function listAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListAccountsApiV2LedgersLedgerCanisterIdAccountsGetRequest' from JSON`,
  );
}
